import { useCallback } from 'react';

import { preloadDefaultAndSpaceClassificationLevels } from '../preload/preloadDefaultAndSpaceClassificationLevels.ts';
import { preloadOrgDefaultClassificationLevelIdQuery } from '../preload/preloadOrgDefaultClassificationLevelIdQuery.ts';

type UsePreloadClassificationEditorQueriesProps = {
	spaceKey?: string | null;
};

type UsePreloadClassificationEditorQueriesReturn = () => void;

export const usePreloadClassificationEditorQueries = ({
	spaceKey,
}: UsePreloadClassificationEditorQueriesProps): UsePreloadClassificationEditorQueriesReturn => {
	return useCallback(() => {
		if (!spaceKey) return;
		preloadDefaultAndSpaceClassificationLevels(spaceKey);
		preloadOrgDefaultClassificationLevelIdQuery();
	}, [spaceKey]);
};
